var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrDataPlaceholder',{staticClass:"outlined pa-12",attrs:{"icon":_vm.icon,"title":_vm.title,"text":_vm.text}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }